import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { MapContainer, TileLayer, CircleMarker, useMap } from 'react-leaflet';
import { useSelector, useDispatch } from 'react-redux';
import ListingGridItem from 'components/common/listing/listing-item/ListingGridItem';
import SimpleBar from 'simplebar-react';
import { setBounds } from 'reducers/homeReducer';
import MapViewListingPopup from './MapViewListingPopup';

const SetBounds = ({ bounds }) => {
  const map = useMap();

  useEffect(() => {
    if (bounds) {
      map.fitBounds(bounds);
    }
  }, [bounds, map]);

  return null;
};

SetBounds.propTypes = {
  bounds: PropTypes.array.isRequired
};

const MapView = () => {
  const { listings, bounds } = useSelector(state => state.home);
  const dispatch = useDispatch();
  useEffect(() => {
    if (listings.length) {
      const allLats = listings.flatMap(l => [l.bounds[0].lat, l.bounds[1].lat]);
      const allLngs = listings.flatMap(l => [l.bounds[0].lng, l.bounds[1].lng]);
      let minLat = Infinity;
      let maxLat = -Infinity;
      let minLng = Infinity;
      let maxLng = -Infinity;
      allLats.forEach(lat => {
        minLat = Math.min(minLat, lat);
        maxLat = Math.max(maxLat, lat);
      });
      allLngs.forEach(lng => {
        minLng = Math.min(minLng, lng);
        maxLng = Math.max(maxLng, lng);
      });
      const bounds = [
        [maxLat + 0.01, minLng - 0.1],
        [minLat - 0.01, maxLng + 0.1]
      ];
      dispatch(setBounds(bounds));
    }
  }, [listings]);

  if (!bounds) {
    return <></>;
  }

  return (
    <Row className="h-100">
      <Col md={3} className="h-100">
        <SimpleBar className="h-100">
          <Row>
            {listings.map(listing => (
              <ListingGridItem
                listing={listing}
                key={listing.id}
                md={12}
                myListingMode={false}
              />
            ))}
          </Row>
        </SimpleBar>
      </Col>

      <Col md={9}>
        <MapContainer zoom={17} zoomSnap={0.5} radius={200} className="h-100">
          <TileLayer
            url={process.env.REACT_APP_LEAFLET_OPENSM_STANDARD_TILE_LAYER_URL}
          />
          <SetBounds bounds={bounds} />
          {listings.map(listing => (
            <CircleMarker
              key={listing.id}
              center={[listing.centroid.lat, listing.centroid.lng]}
              fillColor="green"
              radius={5}
            >
              <MapViewListingPopup listing={listing} />
            </CircleMarker>
          ))}
        </MapContainer>
      </Col>
    </Row>
  );
};

export default MapView;
